interface LeaveConfirmModalProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export default function LeaveConfirmModal({ open, onStay, onLeave }: LeaveConfirmModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60" onClick={onStay} />

      {/* Dialog */}
      <div className="relative bg-veritas-navy border border-white/10 rounded-lg p-6 w-full max-w-sm mx-4 shadow-xl">
        <h2 className="text-white font-sans font-semibold text-base mb-2">Leave this page?</h2>
        <p className="text-white/60 text-sm mb-6">Your progress will be lost if you leave now.</p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onStay}
            className="px-4 py-2 text-sm font-sans font-medium text-white bg-white/10 hover:bg-white/20 rounded transition-colors"
          >
            Stay
          </button>
          <button
            onClick={onLeave}
            className="px-4 py-2 text-sm font-sans font-medium text-white bg-red-600 hover:bg-red-700 rounded transition-colors"
          >
            Leave anyway
          </button>
        </div>
      </div>
    </div>
  );
}
